/**
 * @file
 * Global utilities.
 *
 */

(function ($, Drupal) {
  window.requestAnimFrame = (function () {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      }
    );
  })();

  Drupal.behaviors.mmtv = {
    attach: function attach(context, settings) {

      const $backToTop = $('.back-top-wrapper');
      const $navbarCollapse = $('.navbar-collapse');
      const $infoCollapse = $('.header-actions');

      let position = 0,
        { isFront } = settings.path,
        animationIn,
        animationOut,
        scheduledAnimation = false,
        isLoggedIn = settings.user.uid > 0 ? true : false,
        $navbarMain = $('.navbar-main.fixed-top'),
        $masthead = $('.masthead'),
        $videosSlider = $(once("video-slider", ".videos-slick-slider > .slick-slider", context)),
        $navItemSmooth = $(once("smooth-nav", ".nav-item-smooth", context));

      $navbarCollapse.on('show.bs.collapse', ev => {
        $infoCollapse.collapse('hide');
      });

      $infoCollapse.on('show.bs.collapse', ev => {
        $navbarCollapse.collapse('hide');
      });

      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
          $('body').addClass('scrolled');
        } else {
          $('body').removeClass('scrolled');
        }
        if (scroll >= 500) {
          $backToTop.addClass('show');
        } else {
          $backToTop.removeClass('show');
        }
      });

      const updateScrollHeader = () => {
        let aniIn = 0,
          aniOut = 0;
          masthedHeight = $masthead.outerHeight() - $navbarMain.outerHeight();

        if (position > masthedHeight) {
          $navbarMain
            // .removeClass('bg-transparent')
            // .addClass('bg-light');
        } else {
          if (!$navbarCollapse.hasClass('show')) {
            $navbarMain
              // .removeClass('bg-light')
              // .addClass('bg-transparent');
          }
        }
        scheduledAnimation = false;
      };

      const requestTick = () => {
        if (!scheduledAnimation) {
          window.requestAnimationFrame(updateScrollHeader);
          scheduledAnimation = true;
        }
      };

      // we trigger some special functions when is homepage
      // if (isFront) {

      //   $(window).once().on('scroll', ev => {
      //     position = $(window).scrollTop();
      //     requestTick();
      //   });

      //   // updateScrollHeader();

      //   $navbarCollapse.on('show.bs.collapse', ev => {
      //     $navbarMain
      //       .removeClass('bg-transparent')
      //       .addClass('bg-light');
      //   });

      //   $navbarCollapse.on('hidden.bs.collapse', ev => {
      //     masthedHeight = $masthead.outerHeight() - $navbarMain.outerHeight();
      //     if (position < masthedHeight) {
      //       $navbarMain
      //         .removeClass('bg-light')
      //         .addClass('bg-transparent');
      //     }
      //   });
      // }

      $videosSlider.each(function (index) {
        $(this)
          .slick({
            arrows: true,
            dots: false,
            swipe: true,
            autoplay: true,
            autoplaySpeed: 2000,
            swipeToSlide: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 1500,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  infinite: true,
                }
              },
              {
                breakpoint: 1100,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 100,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
      });

      //Smooth scroll behaviour
      $navItemSmooth.on('click', function (ev) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') ===
          this.pathname.replace(/^\//, '') &&
          location.hostname === this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $('[name=' + this.hash.slice(1) + ']');

          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            target.addClass('smooth-target');

            $('html, body').animate(
              {
                scrollTop: target.offset().top - $('#navbar-main').outerHeight() - 50
              },
              1000
            );
          }
        }
      });


    }
  };

  Drupal.behaviors.parallax = {
    attach: function attach(context, settings) {

      const controller = new ScrollMagic.Controller();
      const $parallaxBlocks = $(once("parallax", ".paragraph--type--bp-background-image", context));


      $parallaxBlocks.each((index, block) => {
        let $bg = $(block).find('.parallax-banner-bg');

        const TL = new TimelineMax();
        TL.from($bg, 1, { y: '-30%', ease: Power0.easeNone })

        const scene = new ScrollMagic.Scene({
          triggerElement: block,
          triggerHook: 1,
          duration: '120%'
        })
          .setTween(TL)
          .addTo(controller);
      });

    }
  };
})(jQuery, Drupal);
